module.exports = __webpack_public_path__ + "img/banner1.184010f7.jpg";